import * as helper from './../../../Assets/Js/helper';
import PaytourHelperClass from "../../../Assets/Js/paytour/PaytourHelperClass";

declare global {
	interface Window { paytourHelper: PaytourHelperClass; }
}

export function PaytourHandler() {
	const $wrapper = helper.$('#wrapper');
	const extender = helper.getData($wrapper, 'extend');
	const targetUrl = helper.getData($wrapper, 'targeturl')
	const ab1 = parseInt(helper.getData($wrapper, 'ab1'), 10);
	const loginButton = document.querySelector('.header-buttons-login');
	const isVxWorld = window.location.host.match(/visit-x\.world/) !== null;

	let PaytourSettings: any = {
		'targetUrl': targetUrl,
		'pfm': 1502,
		'host': 0,
		'hideClose': false,
		'minAmount': 2500, // cents
		'disableJump': true,
		'option': '2XITGA',
	};

	const links = $wrapper.querySelectorAll('.paytour');
	links.forEach((link) => {
		if (!helper.hasClass(link, 'nopaytour')) {
			if (isVxWorld && link === loginButton) {
				helper.addClickListener(loginButton, (evt: MouseEvent) => {
					evt.preventDefault();
					window.location.href = 'https://www.visit-x.net/de/kategorien/?vxpAutoFlow=Login&' + extender;
				});
			} else {
				helper.addEventListener(link, 'click', (evt: MouseEvent) => {
					evt.preventDefault();
					if (ab1 === 2) {
						window.location = targetUrl;
					} else if (ab1 === 1) {
						window.paytourHelper.openSignup(PaytourSettings);
					} else {
						window.paytourHelper.openPaytour(PaytourSettings);
					}
				})
			}
		}
	})
}
